'use strict';

export default class DepartementBlock {
  constructor(options) {
    console.log('DepartementBlock module');

    const defaults = {
      departmentForm: '#departementBlock__form_F select[name="Service"]'
    };

    this.options = Object.assign({}, defaults, options);

    this._initForm();
    this._listemForm();
  }

  _initForm() {
    let service = window.location.pathname.split('/').slice(1,2);

    if (service[0] && service[0] !== '' && $('option[value="' + service[0] + '"]', $(this.options.departmentForm)).length > 0) {
      $(this.options.departmentForm).val(service[0]);
    }
  }

  _listemForm() {
    $('#departementBlock__form_F').submit(function(){
      window.location.assign("/"+this.Service.value+"/"+this.Departement.value);
      return false;
    });

    $('.departementBlock__button').click(function(){
      $('#departementBlock__form_F').submit();
    });
  }
}
